import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import './TablesManager.css';

export default class TablesManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalRows: 0,
      page: 1,
      perPage: 10,
      selectedTable: 'cities', // Текущее выбранное состояние таблицы
      selectedTabSet: 'set1', // Текущее выбранное состояние набора вкладок
    };
  }  

  componentDidMount() {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      console.error('No token found');
      return;
    }
  
    this.fetchTableData(this.state.selectedTable, this.state.page, this.state.perPage).then(response => {
      if (!response || !response.data) {
        console.error('Response data is undefined:', response);
        this.setState({ data: [], totalRows: 0 });
        return;
      }
  
      const dataToSet = Array.isArray(response.data) ? response.data : [];
      this.setState({ data: dataToSet, totalRows: response.total || 0 }, () => {
        console.log('State updated with new data:', this.state);
      });
    }).catch(error => {
      console.error('Error fetching data:', error);
      this.setState({ data: [], totalRows: 0 });
    });
  }
  
  fetchTableData = async (table, page = 1, perPage = 10) => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      console.log('No token found');
      return Promise.resolve({ data: [], total: 0 });
    }
  
    try {
      const response = await fetch(`http://localhost:8080/admin-${table}?page=${page}&pageSize=${perPage}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return { data: data.tickets || data.data || data || [], total: data.total || 0 };
    } catch (error) {
      console.error('Error fetching data:', error);
      return { data: [], total: 0 };
    }
  }

  handleTabChange = (tabSet, initialTable) => {    
    this.setState({ selectedTabSet: tabSet, selectedTable: initialTable, page: 1, data: [] }, () => {  
      this.fetchTableData(initialTable, 1, this.state.perPage).then(response => {        
        if (!response || !Array.isArray(response.data)) {
          console.error('Data is undefined or not an array:', response.data);
          this.setState({ data: [], totalRows: 0 });
          return;
        }
        
        const dataToSet = response.data;
        
        // Дополнительная проверка перед установкой состояния
        if (!Array.isArray(dataToSet)) {
          console.error('Data to set in state is not an array:', dataToSet);
          this.setState({ data: [], totalRows: 0 });
          return;
        }
  
        this.setState({ data: dataToSet, totalRows: response.total }, () => {
          console.log('State updated with new data:', this.state);
        });
      }).catch(error => {
        console.error('Error fetching data:', error);
        this.setState({ data: [], totalRows: 0 });
      });
    });
  }  
  
  handlePageChange = (page) => {
    this.fetchTableData(this.state.selectedTable, page, this.state.perPage).then(data => {
      if (!data) {
        console.error('Data is undefined');
        return;
      }
      const dataToSet = Array.isArray(data.data) ? data.data : [];
      this.setState({ data: dataToSet, totalRows: data.total, page });
    });
  }
  
  handlePerRowsChange = (newPerPage, page) => {
    this.fetchTableData(this.state.selectedTable, page, newPerPage).then(data => {
      if (!data) {
        console.error('Data is undefined');
        return;
      }
      const dataToSet = Array.isArray(data.data) ? data.data : [];
      this.setState({ data: dataToSet, totalRows: data.total, page, perPage: newPerPage });
    });
  }
  
  handleCreateItem = (table) => {
    const token = localStorage.getItem('adminToken');
    const newItemData = this.collectNewItemData(table);
  
    if (!newItemData) {
      alert('Данные для нового элемента не могут быть пустыми.');
      return;
    }
  
    fetch(`http://localhost:8080/admin-${table}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newItemData)
    })
    .then(response => {
      return response.json().then(data => {
        if (!response.ok) {
          throw new Error(data.message || response.statusText);
        }
        return data;
      });
    })
    .then(data => {
      if (data.errors) {
        console.error('Validation or save errors:', data.errors);
      } else {
        this.setState(prevState => ({
          data: [...prevState.data, data]
        }));
        console.log('New item created:', data);
      }
    })
    .catch(error => {
      console.error('Error creating new item:', error.message);
    });
  }

  collectNewItemData = (table) => {
    switch (table) {
      case 'concerts':
        return {
          city_id: prompt("Введите ID города:"),
          concert_date: prompt("Введите дату концерта (YYYY-MM-DD):"),
          time_start: prompt("Введите время начала (HH:MM:SS):"),
          duration: prompt("Введите длительность (в минутах):"),
          image: prompt("Введите ссылку на изображение:"),
          address: prompt("Введите адрес:")
        };
      case 'ticket-types':
        return {
          name: prompt("Введите наименование типа билета:")
        };
      case 'users':
        return {
          token: prompt("Введите токен пользователя:")
        };
      case 'product-types':
        return {
          name: prompt("Введите наименование типа:")
        };
      case 'albums':
        return {
          number: prompt("Введите номер альбома:"),
          name: prompt("Введите название альбома:"),
          image: prompt("Введите ссылку на изображение для обложки:"),
          background: prompt("Введите ссылку на изображение для заднего плана:")
        };
      case 'cities':
        return {
          name: prompt("Введите название города:")
        };
      case 'products':
        return {
          name: prompt("Введите наименование товара:"),
          cost: prompt("Введите стоимость товара:"),
          description: prompt('Введите описание товара ({"...","..."}):'),
          image: prompt("Введите ссылку на изображение для карточки товара:"),
          type_id: prompt("Введите ID типа товара:")
        };
      case 'purchases':
        return {
          item_id: prompt("Введите ID товара:"),
          quantity: prompt("Введите количество товара:"),
          size: prompt("Введите размер товара:"),
          user_id: prompt('Введите ID пользователя:'),
          purchase_date: prompt("Введите дату покупки (YYYY-MM-DD):"),
          total_price: prompt("Введите итоговую стоимость:")
        };
      case 'songs':
        return {
          name: prompt("Введите название песни:"),
          line: prompt("Введите строку из песни:"),
          youtube: prompt("Введите ссылку на youtube (или null):"),
          deezer: prompt("Введите ссылку на deezer (или null):"),
          vk: prompt('Введите ссылку на vk (или null):'),
          spotify: prompt("Введите ссылку на spotify (или null):"),
          yandex: prompt("Введите ссылку на yandex (или null):"),
          apple: prompt("Введите ссылку на apple (или null):"),
          album_id: prompt("Введите ID альбома:")
        };
      case 'tickets':
        return {
          city_id: prompt("Введите ID города:"),
          cost: prompt('Введите стоимость билета:'),
          type_id: prompt("Введите ID типа:"),
          user_id: prompt("Введите ID пользователя:"),
          row: prompt("Введите номер ряда билета:"),
          number: prompt("Введите номер места билета:"),
          status: prompt("Введите статус билета (sold или null):")
        };
      case 'ticket-types':
        return {
          name: prompt("Введите наименование типа:")
        };
      case 'user-basket':
        return {
          user_id: prompt("Введите ID пользователя:"),
          product_id: prompt("Введите ID товара:"),
          count: prompt("Введите количество товара:"),
          size: prompt("Введите размер товара (S, L, XL, XLL):"),
          type_id: prompt("Введите ID типа товара:")
        };
      case 'user-favorite':
        return {
          user_id: prompt("Введите ID пользователя:"),
          product_id: prompt("Введите ID товара:")
        };
      default:
        return null;
    }
  }  
  
  handleEditItem = (table, id) => {
    switch (table) {
      case 'concerts':
        this.handleEditConcert(id);
        break;
      case 'ticket-types':
        this.handleEditTicketType(id);
        break;
      case 'users':
        this.handleEditUser(id);
        break;
      default:
        this.handleEditGeneric(table, id);
        break;
    }
  }
  
  handleEditConcert = (id) => {
    const concertData = {
      city_id: prompt("Введите новый ID города:"),
      concert_date: prompt("Введите новую дату концерта (YYYY-MM-DD):"),
      time_start: prompt("Введите новое время начала (HH:MM:SS):"),
      duration: prompt("Введите новую длительность (в минутах):"),
      image: prompt("Введите новую ссылку на изображение:"),
      address: prompt("Введите новый адрес:")
    };

    for (let key in concertData) {
      if (!concertData[key] || concertData[key].trim() === "") {
        alert(`${key} не может быть пустым.`);
        return;
      }
    }

    const token = localStorage.getItem('adminToken');

    fetch(`http://localhost:8080/admin-concerts/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(concertData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      if (data.errors) {
        console.error('Validation or save errors:', data.errors);
      } else {
        this.setState(prevState => ({
          data: prevState.data.map(item => 
            item.id === id ? { ...item, ...concertData } : item
          )
        }));
        console.log(`Concert with ID: ${id} updated.`);
      }
    })
    .catch(error => {
      console.error('Error updating concert:', error.message);
    });
  }

  handleEditTicketType = (id) => {
    const newName = prompt("Введите новое наименование типа билета:");
    if (!newName || newName.trim() === "") {
      alert("Наименование типа билета не может быть пустым.");
      return;
    }

    const token = localStorage.getItem('adminToken');

    fetch(`http://localhost:8080/admin-ticket-types/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ type_name: newName.trim() })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      if (data.errors) {
        console.error('Validation or save errors:', data.errors);
      } else {
        this.setState(prevState => ({
          data: prevState.data.map(item => 
            item.id === id ? { ...item, type_name: data.type_name } : item
          )
        }));
        console.log(`Ticket type with ID: ${id} updated.`);
      }
    })
    .catch(error => {
      console.error('Error updating ticket type:', error.message);
    });
  }

  handleEditUser = (id) => {
    const newToken = prompt('Введите новый токен пользователя:');
    if (!newToken || newToken.trim() === "") {
      alert('Токен пользователя не может быть пустым.');
      return;
    }
  
    const token = localStorage.getItem('adminToken');
  
    fetch(`http://localhost:8080/admin-users/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ token: newToken.trim() })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      if (data.errors) {
        console.error('Validation or save errors:', data.errors);
      } else {
        this.setState(prevState => ({
          data: prevState.data.map(item => 
            item.id === id ? { ...item, token: data.token } : item
          )
        }));
        console.log(`User with ID: ${id} updated.`);
      }
    })
    .catch(error => {
      console.error('Error updating user:', error.message);
    });
  }  

  handleEditGeneric = (table, id) => {
    const newName = prompt(`Введите новое ${table.slice(0, -1)} имя:`);
    if (!newName) {
      return;
    }
  
    const token = localStorage.getItem('adminToken');
  
    fetch(`http://localhost:8080/admin-${table}/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ name: newName })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.json();
    })
    .then(data => {
      if (data.errors) {
        console.error('Validation or save errors:', data.errors);
      } else {
        this.setState(prevState => ({
          data: prevState.data.map(item => 
            item.id === id ? { ...item, name: data.name } : item
          )
        }));
        console.log(`${table.slice(0, -1)} with ID: ${id} updated.`);
      }
    })
    .catch(error => {
      console.error(`Error updating ${table.slice(0, -1)} name:`, error.message);
    });
  }  

  handleDeleteItem = (table, id) => {
    const token = localStorage.getItem('adminToken');
    fetch(`http://localhost:8080/admin-${table}/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      } else {
        this.setState(prevState => ({
          data: prevState.data.filter(item => item.id !== id),
        }));
        console.log(`Deleted ${table.slice(0, -1)} with ID: ${id}`);
      }
    })
    .catch(error => {
      console.error(`Error deleting ${table.slice(0, -1)}:`, error.message);
    });
  }
  
  render() {
    const { selectedTable, selectedTabSet, data, totalRows, page, perPage } = this.state;
  
    const columns = selectedTable === 'concerts' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Идентификатор города',
        selector: row => row.city_id,
        sortable: true,
      },
      {
        name: 'Дата концерта',
        selector: row => row.concert_date,
        sortable: true,
      },
      {
        name: 'Время начала',
        selector: row => row.time_start,
        sortable: true,
      },
      {
        name: 'Длительность',
        selector: row => row.duration,
        sortable: true,
      },
      {
        name: 'Логотип площадки',
        selector: row => row.image,
        sortable: true,
      },
      {
        name: 'Адрес',
        selector: row => row.address,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'ticket-types' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Тип билета',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'users' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Ключ',
        selector: row => row.token,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'tickets' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Идентификатор города',
        selector: row => row.city_id,
        sortable: true,
      },
      {
        name: 'Место',
        selector: row => row.number,
        sortable: true,
      },
      {
        name: 'Стоимость',
        selector: row => row.cost,
        sortable: true,
      },
      {
        name: 'Идентификатор типа',
        selector: row => row.type_id,
        sortable: true,
      },
      {
        name: 'Идентификатор пользователя',
        selector: row => row.user_id,
        sortable: true,
      },
      {
        name: 'Ряд',
        selector: row => row.row,
        sortable: true,
      },
      {
        name: 'Статус',
        selector: row => row.status,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'cities' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Название',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'albums' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Номер',
        selector: row => row.number,
        sortable: true,
      },
      {
        name: 'Название',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Обложка',
        selector: row => row.image,
        sortable: true,
      },
      {
        name: 'Заставка',
        selector: row => row.background,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'songs' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Название',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Строка',
        selector: row => row.line,
        sortable: true,
      },
      {
        name: 'Youtube',
        selector: row => row.youtube,
        sortable: true,
      },
      {
        name: 'Deezer',
        selector: row => row.deezer,
        sortable: true,
      },
      {
        name: 'Vk',
        selector: row => row.vk,
        sortable: true,
      },
      {
        name: 'Spotify',
        selector: row => row.spotify,
        sortable: true,
      },
      {
        name: 'Yandex',
        selector: row => row.yandex,
        sortable: true,
      },
      {
        name: 'Apple',
        selector: row => row.apple,
        sortable: true,
      },
      {
        name: 'Идентификатор альбома',
        selector: row => row.album_id,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'user-basket' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Идентификатор пользователя',
        selector: row => row.user_id,
        sortable: true,
      },
      {
        name: 'Идентификатор товара',
        selector: row => row.product_id,
        sortable: true,
      },
      {
        name: 'Количество',
        selector: row => row.count,
        sortable: true,
      },
      {
        name: 'Размер',
        selector: row => row.size,
        sortable: true,
      },
      {
        name: 'Идентификатор типа',
        selector: row => row.type_id,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'user-favorite' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Идентификатор пользователя',
        selector: row => row.user_id,
        sortable: true,
      },
      {
        name: 'Идентификатор товара',
        selector: row => row.product_id,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'products' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Наименование',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Стоимость',
        selector: row => row.cost,
        sortable: true,
      },
      {
        name: 'Описание',
        selector: row => row.description,
        sortable: true,
      },
      {
        name: 'Изображение',
        selector: row => row.image,
        sortable: true,
      },
      {
        name: 'Идентификатор типа',
        selector: row => row.type_id,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'product-types' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Наименование',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : selectedTable === 'purchases' ? [
      {
        name: 'Идентификатор',
        selector: row => row.id,
        sortable: true,
      },
      {
        name: 'Идентификатор товара',
        selector: row => row.item_id,
        sortable: true,
      },
      {
        name: 'Количество',
        selector: row => row.quantity,
        sortable: true,
      },
      {
        name: 'Размер',
        selector: row => row.size,
        sortable: true,
      },
      {
        name: 'Идентификатор пользователя',
        selector: row => row.user_id,
        sortable: true,
      },
      {
        name: 'Дата покупки',
        selector: row => row.purchase_date,
        sortable: true,
      },
      {
        name: 'Итоговая стоимость',
        selector: row => row.total_price,
        sortable: true,
      },
      {
        name: 'Действия',
        cell: row => (
          <div>
            <button className='admin_tables_cities_button' onClick={() => this.handleEditItem(selectedTable, row.id)}>Редактировать</button>
            <button className='admin_tables_cities_button' onClick={() => this.handleDeleteItem(selectedTable, row.id)}>Удалить</button>
          </div>
        ),
      }
    ] : [];

    const dataToRender = Array.isArray(data) ? data : [];
    return (
      <div className='admin_tables_cities'>
        <div className="admin_tables_changer up">
          <button className={selectedTabSet === 'set1' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'cities')}>Концерты</button>
          <button className={selectedTabSet === 'set2' ? 'active' : ''} onClick={() => this.handleTabChange('set2', 'albums')}>Музыка</button>
          <button className={selectedTabSet === 'set3' ? 'active' : ''} onClick={() => this.handleTabChange('set3', 'users')}>Пользователи</button>
          <button className={selectedTabSet === 'set4' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'products')}>Магазин</button>
        </div>
        {selectedTabSet === 'set1' ? (
          <div className="admin_tables_changer">
            <button className={selectedTable === 'cities' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'cities')}>Города</button>
            <button className={selectedTable === 'concerts' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'concerts')}>Концерты</button>
            <button className={selectedTable === 'users' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'users')}>Пользователи</button>
            <button className={selectedTable === 'tickets' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'tickets')}>Билеты</button>
            <button className={selectedTable === 'ticket-types' ? 'active' : ''} onClick={() => this.handleTabChange('set1', 'ticket-types')}>Типы билетов</button>
          </div>
        ) : selectedTabSet === 'set2' ? (
          <div className="admin_tables_changer">
            <button className={selectedTable === 'albums' ? 'active' : ''} onClick={() => this.handleTabChange('set2', 'albums')}>Альбомы</button>
            <button className={selectedTable === 'songs' ? 'active' : ''} onClick={() => this.handleTabChange('set2', 'songs')}>Композиции</button>
          </div>
        ) : selectedTabSet === 'set3' ? (
          <div className="admin_tables_changer">
            <button className={selectedTable === 'users' ? 'active' : ''} onClick={() => this.handleTabChange('set3', 'users')}>Пользователи</button>
            <button className={selectedTable === 'user-basket' ? 'active' : ''} onClick={() => this.handleTabChange('set3', 'user-basket')}>Корзины</button>
            <button className={selectedTable === 'user-favorite' ? 'active' : ''} onClick={() => this.handleTabChange('set3', 'user-favorite')}>Избранные</button>
          </div>
        ) : (
          <div className="admin_tables_changer">
            <button className={selectedTable === 'products' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'products')}>Товары</button>
            <button className={selectedTable === 'product-types' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'product-types')}>Типы товаров</button>
            <button className={selectedTable === 'purchases' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'purchases')}>Продажи</button>
            <button className={selectedTable === 'users' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'users')}>Пользователи</button>
            <button className={selectedTable === 'user-basket' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'user-basket')}>Корзины</button>
            <button className={selectedTable === 'user-favorite' ? 'active' : ''} onClick={() => this.handleTabChange('set4', 'user-favorite')}>Избранные</button>
          </div>
        )}
        <DataTable
          columns={columns}
          data={dataToRender}
          pagination
          paginationTotalRows={totalRows}
          paginationDefaultPage={page}
          paginationPerPage={perPage}
          onChangeRowsPerPage={this.handlePerRowsChange}
          onChangePage={this.handlePageChange}
          className='admin_tables_cities_datatable'
        />
        <div className='admin_tables_cities_create'>
          <button className='admin_tables_cities_button' onClick={() => this.handleCreateItem(selectedTable)}>Добавить</button>
        </div>
        <div id="customPrompt" class="modal">
          <div class="modal-content">
            <span class="close" onclick="closePrompt()">&times;</span>
            <p>Введите данные:</p>
            <input type="text" id="promptInput" />
            <button onclick="submitPrompt()">OK</button>
          </div>
        </div>
      </div>   
    );
  }  
}